import { html, nothing } from "lit";
import { t } from "../../i18n/index.ts";
import { formatRelativeTimestamp } from "../format.ts";
import { renderChannelConfigSection } from "./channels.config.ts";
import type { ChannelsProps } from "./channels.types.ts";

export function renderOneHammerZaloCard(params: {
  props: ChannelsProps;
  status?: {
    configured?: boolean;
    running?: boolean;
    connected?: boolean | null;
    lastError?: string | null;
    lastStartAt?: number | null;
    lastStopAt?: number | null;
    lastInboundAt?: number | null;
    lastOutboundAt?: number | null;
  };
  accountCountLabel: unknown;
}) {
  const { props, status, accountCountLabel } = params;

  console.log("[OpenClaw UI] renderOneHammerZaloCard called");
  console.log("[OpenClaw UI] OneHammer Zalo status:", status);
  console.log("[OpenClaw UI] props.snapshot:", props.snapshot);
  console.log("[OpenClaw UI] props.snapshot?.channelAccounts?.onehammerzalo:", props.snapshot?.channelAccounts?.onehammerzalo);

  return html`
    <div class="card">
      <div class="card-title">${t("channels.zaloTitle")}</div>
      <div class="card-sub">${t("channels.zaloSub")}</div>
      ${accountCountLabel}

      <div class="status-list" style="margin-top: 16px;">
        <div>
          <span class="label">${t("channels.configured")}</span>
          <span>${status?.configured ? t("channels.yes") : t("channels.no")}</span>
        </div>
        <div>
          <span class="label">${t("channels.running")}</span>
          <span>${status?.running ? t("channels.yes") : t("channels.no")}</span>
        </div>
        <div>
          <span class="label">${t("channels.connected")}</span>
          <span>${status?.connected == null ? t("common.na") : status.connected ? t("channels.yes") : t("channels.no")}</span>
        </div>
        <div>
          <span class="label">${t("channels.lastInbound")}</span>
          <span>
            ${status?.lastInboundAt ? formatRelativeTimestamp(status.lastInboundAt) : "n/a"}
          </span>
        </div>
      </div>

      ${
        !status?.configured
          ? html`<div class="callout" style="margin-top: 12px; background: var(--bg-elevated); border-left: 3px solid var(--accent);">
              <strong>${t("channels.notLoggedIn")}</strong><br/>
              ${t("channels.notLoggedInHint")}
            </div>`
          : status?.lastError && status.lastError !== "not configured"
            ? html`<div class="callout danger" style="margin-top: 12px;">
                ${status.lastError}
              </div>`
            : nothing
      }

      ${
        props.ohzMessage
          ? html`<div class="callout" style="margin-top: 12px;">
            ${props.ohzMessage}
          </div>`
          : nothing
      }

      ${
        props.ohzQrDataUrl
          ? html`<div class="qr-wrap">
            <img src=${props.ohzQrDataUrl} alt="Zalo QR" />
          </div>`
          : nothing
      }

      <div class="row" style="margin-top: 14px; flex-wrap: wrap; gap: 8px;">
        ${
          status?.configured
            ? status?.running
              ? html`<button
                  class="btn"
                  @click=${() => props.onChannelStop("onehammerzalo")}
                >
                  ${t("channels.stop")}
                </button>`
              : html`<button
                  class="btn primary"
                  @click=${() => props.onChannelStart("onehammerzalo")}
                >
                  ${t("channels.start")}
                </button>`
            : nothing
        }
        <button
          class="btn ${!status?.configured ? "primary" : ""}"
          ?disabled=${props.ohzBusy}
          @click=${() => props.onOhzStart(false)}
        >
          ${props.ohzBusy ? t("channels.working") : t("channels.showQr")}
        </button>
        <button
          class="btn"
          ?disabled=${props.ohzBusy}
          @click=${() => props.onOhzStart(true)}
        >
          ${t("channels.relink")}
        </button>
        <button
          class="btn"
          ?disabled=${props.ohzBusy}
          @click=${() => props.onOhzWait()}
        >
          ${t("channels.waitForScan")}
        </button>
        ${
          status?.configured
            ? html`<button
                class="btn danger"
                ?disabled=${props.ohzBusy}
                @click=${() => props.onOhzLogout()}
              >
                ${t("channels.logout")}
              </button>`
            : nothing
        }
        <button class="btn" @click=${() => props.onRefresh(true)}>
          ${t("channels.refresh")}
        </button>
        ${
          status?.configured
            ? html`<button class="btn" @click=${() => props.onShowPairing?.("zalouser", "OneHammer Zalo")}>
                ${t("channels.managePairing")}
              </button>`
            : nothing
        }
      </div>

      ${renderChannelConfigSection({ channelId: "onehammerzalo", props })}
    </div>
  `;
}
